// extracted by mini-css-extract-plugin
export default {"chipGroup":"styles-module__chipGroup__f2935bc46a779af97356"};